import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import RecordCount from "../../../assets/SharedComponents/RecordCount/RecordCount";
import { Tooltip } from "@mui/material";
import { ThreeDots } from "react-loader-spinner";
import { Wrapper } from "./style";
import API from "../../../api/axios";
import { APP_URLS } from "../../../api/url";
import { APIError, showUserTypeBadge } from "../../../core/utils";
import back from "../../../assets/Images/icons/svgIcon/back-arrow.svg";
import { FaFilterIcon } from "../../../assets/Images/icon";
import NoRecord from "../../../assets/SharedComponents/Table/NoRecord";
import Pagination from "../../../assets/SharedComponents/Pagination";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { userTypes } from "../../../config/constant";

const Chats = () => {

  const navigate = useNavigate()
  const { userType, userId } = useParams()

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [chats, _chats] = useState([]);
  const [page, setPage] = useState(1);
  const [total, _total] = useState(0);
  const [totalPage, _totalPage] = useState(0);

  const [userTypeFilter, _userTypeFilter] = useState(userTypes.Dealer);
  const hideTrashedParam = searchParams.get("hideTrashed");
  const [hideTrashed, _hideTrashed] = useState(
    hideTrashedParam === null ? true : hideTrashedParam === "true"
  );
  const [filters, _filters] = useState(false);

  const [countValue, _countValue] = useState(10);

  const [chatsloader, _chatsloader] = useState(false);

  useEffect(() => {
    getReportedChats();
  }, [page, countValue, userTypeFilter, hideTrashed]);

  const getReportedChats = () => {
    _chatsloader(true);
    API.get(
      `${APP_URLS.GET_CHATS}/${userId}/${userType}?page=${page}&per_page=${countValue}&filter[user_type]=${userType}&with_trashed=${!hideTrashed ? "1" : "0"}`
    )
      .then((res) => {
        const resp = res.data;
        if (resp.success === true) {
          _chats(resp.data.data);
          _total(resp.data.total);
          _totalPage(resp.data.last_page);
        } else {
          toast.error(resp.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(function (error) {
        let error_message = APIError(error);
        toast.error(error_message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .finally(() => {
        _chatsloader(false);
      });
  };

  const handleChange = (searchValue) => {
    _countValue(searchValue);
    _totalPage(0);
    setPage(1);
  };

  //removing all filters
  const clearFilter = () => {
    _filters(true);
    _countValue(10);
    _hideTrashed(true);
    _totalPage(0);
    setPage(1);
  };


  return (
    <>
      <Wrapper>
        <div className="auctionMainContainer">
          <div className="row mt-4">
            <div className="col-md-4 d-flex align-items-center">
              <img src={back} className="ms-4 backbtn" onClick={() => navigate(-1)} />
            </div>
            <div className="col-md-4 text-align-center">
              <h1>Chats</h1>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-end info-wrap mt-3 mb-2 gap-2">
            <RecordCount
              onSearchClick={(search) => handleChange(search)}
              id="pageCount"
              val={countValue}
              filters={filters}
              _filters={_filters}
            />
            <Tooltip title="Clear Filter" placement="bottom">
              <FaFilterIcon
                className="filter-icon"
                role="button"
                onClick={clearFilter}
              />
            </Tooltip>
          </div>
          <div className="d-flex align-items-center justify-content-between info-wrap mt-3 mb-2">
            <span className="text-start">
              Total Records : <b>{total}</b>
            </span>
            <div>
              <input
                type="checkbox"
                checked={hideTrashed}
                onChange={() => {
                  _hideTrashed((prevValue) => !prevValue)
                  _totalPage(0);
                  setPage(1);
                }}
              />
              <span className="ms-2">Hide Deleted Data</span>
            </div>
          </div>
          <div className="tableContainer">
            <table className="auctionTable">
              <thead className="tableHead">
                <tr className="table-row">
                  <th>Chat ID</th>
                  <th className="receiver">User</th>
                  <th className="message-box">Last message</th>
                  <th>Last message time</th>
                  <th>View</th>
                </tr>
              </thead>
              {chatsloader ? (
                <div className="d-flex justify-content-center three-dot">
                  <ThreeDots
                    height="150"
                    width="150"
                    radius="9"
                    color="#637df4"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                  />
                </div>
              ) : (
                <tbody>
                  {chats.length > 0 ? (
                    chats.map((chat) => {
                      return (
                        <tr className={`${chat.deleted_at ? "deletedRow" : ""} table-row`} key={`${chat.last_chat_at} ${chat.id}`}>
                          <td>{chat.id}</td>
                          <td className="receiver">
                            <a
                              href={`${chat.opposite_party_type == 'subsidiary'
                                ? "/company-details"
                                : "/detail-member"
                                }/${chat.opposite_party_id}`}
                              className="link"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <b>
                                {chat.opposite_party_name}
                                {showUserTypeBadge(chat.opposite_party_type)}
                              </b>
                            </a>
                          </td>
                          <td className="message-box">
                            {chat?.last_message?.message
                              ? chat.last_message.message.length > 180
                                ? chat.last_message.message.slice(0, 180) + "..."
                                : chat.last_message.message
                              : "-"}
                          </td>
                          <td>
                            {chat?.last_chat_at ?
                              moment(chat.last_chat_at)
                                .tz("Europe/Amsterdam")
                                .format("DD-MM-YYYY HH:mm")
                              : "-"
                            }
                          </td>
                          <td>
                            <Link
                              to={`/chats-messages/${chat.id}?from=chats`}
                              className="link"
                            >
                              View
                            </Link>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <NoRecord />
                  )}
                </tbody>
              )}
            </table>
          </div>
          <div>
            {totalPage > 1 ? (
              <Pagination
                totalPages={totalPage}
                page={page}
                key={totalPage}
                onPageClick={(page) => setPage(page + 1)}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </Wrapper>
    </>
  );
};

export default Chats;
